import { MainNavItem, SidebarNavItem } from '@/types/nav';

interface CommandMenuConfig {
  mainNav: MainNavItem[];
  sidebarNav: SidebarNavItem[];
}

export const commandMenuConfig: CommandMenuConfig = {
  mainNav: [
    {
      title: 'Go to Home',
      href: '/'
    },
    {
      title: 'Go to Dashboard',
      href: '/dashboard'
    },
    {
      title: 'Go to Courses',
      href: '/courses'
    },
    {
      title: 'Go to External Courses',
      href: '/courses/external'
    },
    {
      title: 'Go to Billing',
      href: '/instructor/dashboard/billing'
    },
    {
      title: 'Go to Transactions',
      href: '/dashboard/transactions'
    },
    {
      title: 'Go to Pricing',
      href: '/pricing'
    },
    {
      title: 'Go to Settings',
      href: '/settings'
    },
    {
      title: 'Go to Account Settings',
      href: '/settings/account'
    },
    {
      title: 'Go to Developer Settings',
      href: '/settings/token'
    },
    {
      title: 'Go to Contact',
      href: '/contact'
    }
  ],
  sidebarNav: []
};
